// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export interface Environment {
  production: boolean;
  apiBaseUrl: string;
  clientId: string;
  authenticationAuthorizeEndpoint: string;
  authenticationRedirectUri: string;
}

export const environment: Environment = {
  production: false,
  apiBaseUrl: window['env']?.apiBaseUrl,
  clientId: window['env']?.clientId,
  authenticationAuthorizeEndpoint: window['env']?.authenticationAuthorizeEndpoint,
  authenticationRedirectUri: window['env']?.authenticationRedirectUri
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
